import React, { CSSProperties } from 'react';

import {HealthData} from './HealthStatusDisplay'
import {checkSnoozeState} from './SnoozeIsotopeDisplay'
import {Config} from './Config'

import * as messages from '@radnuc/messages';

import { t } from 'i18next';
import './i18n';
//import i18n from './i18n';

import './MetricsDisplay.css';
import './StatusHeader.css';
import './SelectLanguageDisplay.css';
import { Textfit } from 'react-textfit';
import i18n from './i18n';

import en_icon from './img/2634451_ensign_flag_nation_states_icon.svg'
import cz_icon from './img/2634499_czech_ensign_flag_nation_icon.svg'
import hu_icon from './img/2634310_ensign_flag_hungary_nation_icon.svg'
import ro_icon from './img/2634396_ensign_flag_nation_romania_icon.svg'
import ru_icon from './img/2634398_ensign_flag_nation_russia_icon.svg'
import sk_icon from './img/2634416_ensign_flag_nation_slovakia_icon.svg'

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;
type PCSResult = messages.Rad.PCSResult;


export interface AcknowledgeAlertInterface {
    acknowledge: (key: Investigation) => void,
    setAlertAcknowledge: (flag:boolean)=> void,
}

export function healthStateToClass(healthState:number){
    switch(healthState){
        case messages.Rad.HealthState.GOOD:
            return 'good'
        case messages.Rad.HealthState.DEGRADED:
            return 'degraded'
        case messages.Rad.HealthState.BAD:
            return 'bad'
        case 4:
            return 'offline'
        default:
            return ''
    }
}

interface CurrentPCSDisplayProps { currentPCSResult: PCSResult | null, healthData: HealthData | undefined, config?: Config}
interface currentPCSDisplayState { time: Date }
export class CurrentPCSDisplay extends React.Component<CurrentPCSDisplayProps, currentPCSDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    dominant_name: string = "--";
    dominant_category: string = "";

    constructor(props: CurrentPCSDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentDidUpdate(prevProps: CurrentPCSDisplayProps) {
        this.findDominantIsotope();
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    findDominantIsotope(){
        var max_isotope = 0;
        var dominant_name = "--";
        var dominant_category = "";

        if(this.props.currentPCSResult != null){
            this.props.currentPCSResult.pcs_result.forEach((isotope)=>{
                if (isotope.pcs_confidence > max_isotope && isotope.alarm) {
                    max_isotope = isotope.pcs_confidence;
                    dominant_name= isotope.name;
                    dominant_category = isotope.category;
                }
            });
            //Optional Snooze Isotope
            if(this.props.config){
                if(checkSnoozeState(this.props.currentPCSResult,this.props.config)){
                    dominant_name = 'MUTED';
                    dominant_category ='MUTED';
                }
            }
        }

        this.dominant_name = dominant_name;
        this.dominant_category = dominant_category;

    }

    hyphenated_nuclide_name(underscore_name: string) {
        var output = underscore_name;
        if (underscore_name.includes("_")) {
            var res = underscore_name.split("_");
            var nuclide_symbol = res[0].toLowerCase();
            var nuclide_number = res[1];
            output = nuclide_symbol[0].toUpperCase() + nuclide_symbol.slice(1) +
                "-" + nuclide_number.toLowerCase();
        }
        return output;
    }

    get_isotope_color(isot_class: string) {
        var this_display_category = isot_class.toUpperCase();
        var color = 'olivedrab'; // NORM

        // COLOR DEFINITION OF
        if (this_display_category.match('INDUSTRIAL')) {
            color = 'orange';
        }
        if (this_display_category.match('RDD')) {
            color = 'orange';
        }
        if (this_display_category.match('MEDICAL')) {
            color = '#4f86f7';
        }
        if (this_display_category.match('SNM')) {
            color = 'red';
        }
        if (this_display_category.match('NUCLEAR')) {
            color = 'red';
        }
        return color;
    }
    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        if(thisHealthData === undefined){
            healthStatusClass =  "offline";
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                healthStatusClass =  '';
            } else {
                healthStatusClass =  "offline";
            }

            var color;
            if(!this.dominant_name.match("--")){
                color = this.get_isotope_color(this.dominant_category);
            }
            if(thisHealthData.state === messages.Rad.HealthState.BAD){
                color = 'red';
            }
        }
        let display_string;
        if(healthStatusClass.match('offline')){
            display_string = t('N/A',{ns:'trans'});
        } else if(this.dominant_name.match('MUTED')){
            display_string = t('MUTED',{ns:'trans'});
        } else {
            display_string =
                <span className='isot-RFG-link-span' style={{ cursor: 'pointer', color: color }}>
                    {t(this.hyphenated_nuclide_name(this.dominant_name),{ns:'trans'})}
                </span>
        }
        const body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px', height:'25px',lineHeight:'25px'}}>
                <label className={"metric "+healthStatusClass}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={16} min={12}>
                        {display_string}
                    </Textfit>
                </label>
            </div>
        return (
            <div className="inv-metric-container" style={{width:'85px', marginTop:'5px', marginBottom:'5px'}}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={12} min={8}>
                        {t('PCS Detection',{ns:'trans'})}
                    </Textfit>
                </label>
                {body}
            </div>
        )
    }
}

interface CurrentCountAndDoseDisplayProps { radiationData: messages.Rad.RadiationReading[] | null, healthData: HealthData | undefined, useDoseRateSIUnit?: boolean}
interface currentCountAndDoseDisplayState { time: Date }
export class CurrentCountAndDoseDisplay extends React.Component<CurrentCountAndDoseDisplayProps, currentCountAndDoseDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: CurrentCountAndDoseDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    calculateCountAndDose(rebinned_spectrum: messages.Rad.RadiationReading){
        var avg_dose = 0;
        var avg_count = 0;
        var num_det_dose = 0;
        var num_det_count = 0;
        var dose_rate_string = t('N/A',{ns:'trans'});
        var count_rate_string = t('N/A',{ns:'trans'});

        if(rebinned_spectrum !== undefined){
            rebinned_spectrum.detectors.forEach(function(det) {
                if (det.spectrum != null) {
                    avg_count = avg_count + (det.spectrum.reduce(function(a, b) {
                        return a + b;
                    }, 0))/det.livetime; //to convert to cps
                    num_det_count++;
                }
                if (det.dose_rate != null) {
                    avg_dose = avg_dose + det.dose_rate;
                    num_det_dose++;
                }
            });
            if (num_det_dose > 0) {
                avg_dose = avg_dose / num_det_dose;
                if(this.props.useDoseRateSIUnit===true){
                    //USE SI UNITS uSv/hr
                    avg_dose = avg_dose / 100;
                }
                //Dose rate string
                if(avg_dose>=100){
                    dose_rate_string = avg_dose.toFixed(0);
                } else if (avg_dose>=10) {
                    dose_rate_string = avg_dose.toFixed(1);
                } else {
                    dose_rate_string = avg_dose.toFixed(2);
                }
            } else {
                dose_rate_string = t('N/A',{ns:'trans'});
            }
            if (num_det_count > 0) {
                avg_count = avg_count / num_det_count;
                count_rate_string = avg_count.toFixed(0);
            } else {
                count_rate_string = t('N/A',{ns:'trans'});
            }
        }
        if(this.props.healthData !== undefined){
            if(this.props.healthData.state === messages.Rad.HealthState.BAD){
                dose_rate_string = t('N/A',{ns:'trans'});
                count_rate_string = t('N/A',{ns:'trans'});
            }
        }

        return({dose_rate_string, count_rate_string});
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        if(thisHealthData === undefined){
            healthStatusClass =  "offline";
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                healthStatusClass =  healthStateToClass(thisHealthData.state);
            } else {
                healthStatusClass =  "offline";
            }
        }

        var dose_display_string = t('N/A',{ns:'trans'});
        var count_display_string = t('N/A',{ns:'trans'});
        if(this.props.radiationData !== null){
            if(this.props.radiationData.length > 0){
                const result = this.calculateCountAndDose(this.props.radiationData[this.props.radiationData.length-1]);
                dose_display_string = result.dose_rate_string;
                count_display_string = result.count_rate_string;
            }
        }
        const count_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{count_display_string}</label>
                <label className="units">{t('cps',{ns:'trans'})}</label>
            </div>
        let dose_rate_unit_string;
        if(this.props.useDoseRateSIUnit===true){
            dose_rate_unit_string = t('μSv/hr',{ns:'trans'})
        } else {
            dose_rate_unit_string = t('μR/hr',{ns:'trans'})
        }
        const dose_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{dose_display_string}</label>
                <label className="units">{t(dose_rate_unit_string,{ns:'trans'})}</label>
            </div>
        return (
            <div style={{ display: 'flex', flexDirection: 'row'}}>
                <div className="inv-metric-container" style={{width:'auto',minWidth:'65px', marginTop:'5px', marginBottom:'5px', maxWidth:'75px'}}>
                    <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                        <Textfit mode="single" forceSingleModeWidth={false} max={12} min={9}>
                            {t('Count Rate',{ns:'trans'})}
                        </Textfit>
                    </label>
                    {count_body}
                </div>
                <div className="inv-metric-container" style={{width:'auto',minWidth:'65px', marginTop:'5px', marginBottom:'5px', maxWidth:'75px'}}>
                    <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                        <Textfit mode="single" forceSingleModeWidth={false} max={12} min={9}>
                            {t('Dose Rate',{ns:'trans'})}
                        </Textfit>
                    </label>
                    {dose_body}
                </div>
            </div>
        )
    }
}

interface CurrentNeutronCountDisplayProps { neutronData: messages.Rad.NeutronReading[] | null, healthData: HealthData | undefined}
interface currentNeutronCountDisplayState { time: Date }
export class CurrentNeutronCountDisplay extends React.Component<CurrentNeutronCountDisplayProps, currentNeutronCountDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: CurrentNeutronCountDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }
    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }
    calculateNeutronCount(neutronData: messages.Rad.NeutronReading){

        var avg_neutron_count = 0;
        var num_det_count = 0;
        var neutron_rate_string = t('N/A',{ns:'trans'});

        if(neutronData !== undefined){
            neutronData.detectors.forEach(function(det) {
                if (det.count != null) {
                    avg_neutron_count = avg_neutron_count + det.count/det.livetime; //to convert to cps
                    num_det_count++;
                }
            });
            if (num_det_count > 0) {
                avg_neutron_count = avg_neutron_count / num_det_count;
                neutron_rate_string = avg_neutron_count.toFixed(1);
            } else {
                neutron_rate_string = t('N/A',{ns:'trans'});
            }
        }
        if(this.props.healthData !== undefined){
            if(this.props.healthData.state === messages.Rad.HealthState.BAD){
                neutron_rate_string = t('N/A',{ns:'trans'});
            }
        }

        return({neutron_rate_string});
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        if(thisHealthData === undefined){
            healthStatusClass =  "offline";
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                healthStatusClass =  healthStateToClass(thisHealthData.state);
            } else {
                healthStatusClass =  "offline";
            }
        }
        var neutron_display_string = t('N/A',{ns:'trans'});
        if(this.props.neutronData !== null){
            if(this.props.neutronData.length > 0){
                const result = this.calculateNeutronCount(this.props.neutronData[this.props.neutronData.length-1]);
                neutron_display_string = result.neutron_rate_string;
            }
        }
        const neutron_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{neutron_display_string}</label>
                <label className="units">{t('cps',{ns:'trans'})}</label>
            </div>
        return (
            <div className="inv-metric-container" style={{width:'auto',minWidth:'65px', marginTop:'5px', marginBottom:'5px', maxWidth:'75px'}}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={12} min={9}>
                        {t('Neutron Rate',{ns:'trans'})}
                    </Textfit>
                </label>
                {neutron_body}
            </div>
        )
    }
}

interface CurrentGPSStatusDisplayProps { position: messages.Core.GPSReading[] | null, healthData: HealthData | undefined}
interface CurrentGPSStatusDisplayState { time: Date }
export class CurrentGPSStatusDisplay extends React.Component<CurrentGPSStatusDisplayProps, CurrentGPSStatusDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: CurrentGPSStatusDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        if(thisHealthData === undefined){
            healthStatusClass =  "offline";
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                healthStatusClass =  healthStateToClass(thisHealthData.state);
            } else {
                healthStatusClass =  "offline";
            }
        }
        var gps_fix_quality_string = t('N/A',{ns:'trans'});
        if(this.props.position !== null){
            if(this.props.position.length > 0){
                const reading = this.props.position[this.props.position.length-1];
                switch (reading.quality) {
                    case 1:
                        gps_fix_quality_string = '2D';
                        break;
                    case 2:
                        gps_fix_quality_string = '3D';
                        break;
                    default:
                        gps_fix_quality_string = t('NONE',{ns:'trans'});
                }
            }
        }
        const body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px', height:'25px',lineHeight:'25px' }}>
                <label className={"metric "+healthStatusClass}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={16} min={12}>
                        {t(gps_fix_quality_string,{ns:'trans'})}
                    </Textfit>
                </label>
            </div>
        let display_width = '50px';
        if (i18n !== undefined && i18n.language !== 'en'){
            display_width = '60px'
        }
        return (
            <div className="inv-metric-container" style={{width:display_width, marginTop:'5px', marginBottom:'5px'}}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={12} min={8}>
                        {t('GPS Fix',{ns:'trans'})}
                    </Textfit>
                    </label>
                {body}
            </div>
        )
    }
}


interface CurrentDiskStatusDisplayProps { healthData: HealthData | undefined }
interface CurrentDiskStatusDisplayState { time: Date }
export class CurrentDiskStatusDisplay extends React.Component<CurrentDiskStatusDisplayProps, CurrentDiskStatusDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;

    constructor(props: CurrentDiskStatusDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        let disk_status_string;
        if(thisHealthData === undefined){
            healthStatusClass =  "offline";
        } else {
            if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
                //Not Timeout
                healthStatusClass =  healthStateToClass(thisHealthData.state);
            } else {
                healthStatusClass =  "offline";
            }

            disk_status_string = thisHealthData.diskUsedPct;
        }
        if(disk_status_string === undefined){
            disk_status_string = '';
        }
        const body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{t(disk_status_string,{ns:'trans'})}</label>
                <label className="units">%</label>
            </div>
        return (
            <div className="inv-metric-container" style={{width:'70px', marginTop:'5px', marginBottom:'5px',fontSize:'unset'}}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={false} max={12} min={8}>
                        {t('Disk Used',{ns:'trans'})}
                    </Textfit>
                </label>
                {body}
            </div>
        )
    }
}

interface AlertAcknowledgeDisplayProps { investigationsNotAcknowledged: Investigation[] | null, acknowledgeAlertInterface: AcknowledgeAlertInterface}
export class AlertAcknowledgeDisplay extends React.Component<AlertAcknowledgeDisplayProps> {

    constructor(props: AlertAcknowledgeDisplayProps) {
        super(props)
        this.handleAlertAcknowledgeButtonClick = this.handleAlertAcknowledgeButtonClick.bind(this);
    }

    handleAlertAcknowledgeButtonClick(){
        this.props.investigationsNotAcknowledged?.forEach((inv)=>{
            this.props.acknowledgeAlertInterface.acknowledge(inv);
        })
    }

    render() {
        let acknowledge_string = "";
        let alertAcknowledgeDisplay;
        if(this.props.investigationsNotAcknowledged === null || this.props.investigationsNotAcknowledged === undefined)
            return;
        //Count only finalized investigations
        let investigationsNotAcknowledgedFinalized = 0;
        this.props.investigationsNotAcknowledged.forEach(inv => {
            if(inv.finalized===true){
                investigationsNotAcknowledgedFinalized++;
            }
        });
        if(investigationsNotAcknowledgedFinalized > 0){
            acknowledge_string = investigationsNotAcknowledgedFinalized.toString();
            if (investigationsNotAcknowledgedFinalized === 1){
                acknowledge_string = acknowledge_string+' Alert';
            } else {
                acknowledge_string = acknowledge_string+' Alerts';
            }
            alertAcknowledgeDisplay =
            <div className="inv-metric-container" style={{width:'70px', minWidth:'70px',marginTop:'5px', marginBottom:'5px', background:'olivedrab'}}
                onClick={()=>{this.handleAlertAcknowledgeButtonClick()}}>
                <label className="metric-title" style={{width:'70px',color:'white'}}>Acknowledge</label>
                <label className={"metric"}>{acknowledge_string}</label>
            </div>
        }
        return (
            <>
            {alertAcknowledgeDisplay}
            </>
        )
    }
}

interface TimeDisplayProps {liveStream: boolean, replayTime?: Date, style?: CSSProperties | undefined}
interface TimeDisplayState { time: Date }
export class TimeDisplay extends React.Component<TimeDisplayProps,TimeDisplayState,{}> {
    updateInterval:number = 1000; //msec
    updateTimer:NodeJS.Timeout | null = null;
    constructor(props: TimeDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount(){
        if(this.updateTimer !== null){
            clearTimeout(this.updateTimer);
        }
    }

    startTimer(){
        if(this.updateTimer !== null){
            clearTimeout(this.updateTimer);
        }
        this.updateTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.updateInterval)
    }

    render() {
        this.startTimer();
        let timeDisplay;
        if(this.props.liveStream){
            const time_now = new Date();
            timeDisplay =
                <div className="time-container inv-metric-container" style={this.props.style}>
                    <label className="metric-title">Current Time</label>
                    <label className="metric">{time_now.toLocaleDateString()+' '+time_now.toLocaleTimeString()}</label>
                </div>
        } else {
            let time_replay_string = t('N/A',{ns:'trans'});
            if(this.props.replayTime !== undefined){
                time_replay_string = this.props.replayTime.toLocaleDateString()+' '+this.props.replayTime.toLocaleTimeString();
            }
            timeDisplay =
                <div className="time-container inv-metric-container" style={this.props.style}>
                    <label className="metric-title">Replay Time</label>
                    <label className="metric">{time_replay_string}</label>
                </div>
        }

        return (
            <>
            {timeDisplay}
            </>
        )
    }
}

//******************************************************************************
//Select language button
interface SelectLanguageInterface { lang:string, select: (lang:string) => void}
export interface SelectLanguageDisplayProps {selectLanguageInterface?:SelectLanguageInterface, style?: CSSProperties, showCountryFlags?: boolean}
export interface SelectLanguageDisplayState {share_dropdown_show:boolean}
export class SelectLanguageDisplay extends React.Component<SelectLanguageDisplayProps,SelectLanguageDisplayState,{}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: SelectLanguageDisplayProps) {
        super(props)
        this.state = {
            share_dropdown_show: false
        }
        this.timeoutTimer = null;
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleSelectLanguage = this.handleSelectLanguage.bind(this);
    }

    componentDidUpdate(prevProps: SelectLanguageDisplayProps) {
        //This sets the language for the react-ui-components
        if(this.props.selectLanguageInterface !== undefined){
            if(i18n.language !== this.props.selectLanguageInterface.lang)
                i18n.changeLanguage(this.props.selectLanguageInterface.lang);
        }
    }

    componentWillUnmount(){
        if(this.timeoutTimer !== null){
            clearTimeout(this.timeoutTimer);
        }
    }

    handleOpenClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: !state.share_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.share_dropdown_show) {
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    share_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }

    handleSelectLanguage(event: React.MouseEvent<HTMLElement>, language:string) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: false
        }));
        if(this.props.selectLanguageInterface !== undefined){
            i18n.changeLanguage(language);
            this.props.selectLanguageInterface.select(language);
        }
    }

    render() {
        
        const languageFlags:{[lang:string]:{icon:any}} = {
          'en': {icon:en_icon},
          'cz': {icon:cz_icon},
          'hu': {icon:hu_icon},
          'ro': {icon:ro_icon},
          'ru': {icon:ru_icon},
          'sk': {icon:sk_icon},
        }
        const languageList = Object.keys(languageFlags);
        let current_language;
        if(this.props.selectLanguageInterface !== undefined){
            current_language = this.props.selectLanguageInterface.lang;
        } else {
            current_language = i18n.language;
        }

        let drowpdownMenuItems:JSX.Element[] = [];
        languageList.forEach((lang,idx) => {
            const thisLanguageFlag = languageFlags[lang].icon;
            let thisLanguageFlagJSX;
            if(this.props.showCountryFlags===true){
                thisLanguageFlagJSX = <img src={thisLanguageFlag} style={{height:'30px',paddingRight:'2px'}}/>
            } else {
                thisLanguageFlagJSX = <div style={{height:'30px',paddingRight:'2px'}}/>
            }
            let thisMenuItem =
                <div key={idx} className="inv-menu-item" onClick={e=>this.handleSelectLanguage(e,lang)}>
                    {thisLanguageFlagJSX}
                    {lang.toUpperCase()}
                </div>
            drowpdownMenuItems.push(thisMenuItem);
        });

        let language_dropdown;
        if (this.state.share_dropdown_show) {
            language_dropdown =
                <div className="inv-share-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                    <div className="plot-title dropdown share-dropdown-surrogate"></div>
                    <div id="language-select-dropdown-content" className="dropdown-content share-dropdown show" style={this.props.style}>
                        {drowpdownMenuItems}
                    </div>
                </div>
        }
        const currentLanguageFlag = languageFlags[current_language].icon;
        let menu_status;
        if(this.props.showCountryFlags===true){
            menu_status = <img src={currentLanguageFlag} className="inv-share-open inv-menu-button dropdownevent plot-title dropdown" id="language-select-dropdown" style={{ height:'30px',paddingRight:'2px', cursor: 'pointer' }}></img>
        } else {
            menu_status = <div id="language-select-dropdown" style={{ height:'30px',paddingTop:'2px',paddingRight:'2px',cursor:'pointer',color:'lightgray'}}>{current_language.toUpperCase()}</div>
        }
        let lang_button =
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <div id="language-select-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    {language_dropdown}
                    <div className="inv-share-container inv-menu-item" style={{marginLeft:'3px'}}>
                        {menu_status}
                    </div>
                </div>
            </div>

        return (
            <div className="inv-metric-container" style={{width:'37px', marginTop:'5px', marginBottom:'5px', overflow:'hidden'}}  onClick={this.handleOpenClick}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={true} max={12} min={8}>
                        {t('Language',{ns:'trans'})}
                    </Textfit>
                </label>
                {lang_button}
                </div>
            </div>

        )
    }
}

//******************************************************************************
